import { URI_ACCOUNTING_CASH } from '@/config/config';

export default async ({ rootState }, payload) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };
  let baseURL = `${URI_ACCOUNTING_CASH}close/all`;

  const query = Object.keys(payload)
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(payload[k])}`)
    .join('&');

  baseURL += `?${query}`;

  const response = await fetch(baseURL, opts);
  const jsonResult = await response.json();
  if (jsonResult.error) {
    return Promise.reject(jsonResult.error);
  }

  return jsonResult;
};
